/*
 * @Descripttion: 人群抽取
 * @Author: xutingting
 * @LastEditors: yang chenglin
 */
import React, { useState, useEffect, useContext } from 'react';
import { Input, Button, Form, Select } from '@alifd/next';
import { ActivityContext } from '../../../../Edit';
import styles from '../../../index.module.scss';
import LzMsg from '@/components/common/LzMsg';

//前置节点为短信节点的抽取状态
const selectTypeList = [
  {
    id: 1,
    name: '全部',
  },{
    id: 2,
    name: '发送成功',
  },{
    id: 3,
    name: '发送失败',
  },
];

export default ({allNodeData =[], prevNodes = [], initData = {}, runState = {}, currentNode = {}, changeData = (data) => {}, onCancel = () => {}, validate = () => {}, getAllNodeIds = []}) => {
  const { graph } = useContext(ActivityContext);

  // 抽取状态
  const [extractionList, setExtractionList] = useState([]);

  // 组件内部的数据
  const [data, setData] = useState({
    ...initData,
    preActName: prevNodes.length ? prevNodes[0].data.name : ''
  });

  /**
   * 合并新旧状态
   */
  const onChange = (newData) => {
    setData({
      ...data,
      ...newData,
    })
  };

  /**
   * 点击确认
   */
  const confirm = async () => {
    try {
      await Promise.all(Object.keys(validate).map(async validator => {
        // 最终校验数据是否填写完整，然后提交给全局
        try {
          if (validator in data) {
            if (validator === 'name') {
              await validate[validator](data[validator], allNodeData, currentNode, getAllNodeIds);
            }
            // 人群抽取节点可由上级去重节点直接生成，因此校验是否连接上级节点拿到这里，不在自己的里面校验，自己的拿不到相应节点信息
            // else if (validator === 'preActName') {
            //   await validate[validator](data[validator], prevNodes);
            // }
            else {
              await validate[validator](data[validator]);
            }
          }
        } catch (e) {
          throw new Error(e);
        }
      }));
      changeData(data);
      graph.updateItem(currentNode.nodeId, {
        targetCrowd: data.preResourceType === 'MARKETING_SMS' ? ['全部', '发送成功', '发送失败'][data.extractType - 1] : data.extractType
      });
    } catch (e) {
      LzMsg.error(e.message);
    }
  };

  /**
   * 点击退出
   */
  const cancel = () => {
    // changeData({preActName: prevNodes.length ? prevNodes[0].data.name : ''}); // 点击取消时，也为前置节点名赋个值，但是在最终保存时提前校验了其他表单，这一步也可以不做。不过这两种方法都不是最优，很难避免一些异常系
    onCancel();
  };

  /**
   * 打开弹窗判断是未填写内容还是已经填写完重新打开 未填写需判断是否有前置节点，有则获取上级节点赋值给抽取人群列表/没有就不做操作直接提示，已填写就拿源数据直接初始化
   */
  useEffect(()=>{
    if(prevNodes.length) {
      // 前置节点是短信
      if(prevNodes[0].info.name === 'MARKETING_SMS' || prevNodes[0].info.name === 'MARKETING_MSG_BOX') {
        setExtractionList(selectTypeList)
        onChange({preResourceType: prevNodes[0].info.name})
      } else if (prevNodes[0].info.name === 'CROWD_SPLIT') { // 前置节点是拆分
        setExtractionList(prevNodes[0].data.splitCrowds)
        const splitCrowdsArr = prevNodes[0].data.splitCrowds.map((item) => {
          return item.searchName
        })
        if(initData.extractType && splitCrowdsArr.indexOf(initData.extractType) === -1) {
          onChange({extractType: '', preResourceType: prevNodes[0].info.name})
        } else {
          onChange({preResourceType: prevNodes[0].info.name})
        }
      } else if (prevNodes[0].info.name === 'CROWD_DIFFERENCE') { // 前置节点是排除
        setExtractionList(prevNodes[0].data.crowdName)
        if(initData.extractType && prevNodes[0].data.crowdName.indexOf(initData.extractType) === -1) {
          onChange({extractType: '', preResourceType: prevNodes[0].info.name})
        } else {
          onChange({preResourceType: prevNodes[0].info.name})
        }
      } else if (['CROWD_INTERSECTION_2', 'CROWD_UNION_2'].indexOf(prevNodes[0].info.name) > -1) { // 前置节点是N交1或N并1
        setExtractionList(prevNodes[0].data.aimNames)
        if(initData.extractType && prevNodes[0].data.aimNames.indexOf(initData.extractType) === -1) {
          onChange({extractType: '', preResourceType: prevNodes[0].info.name})
        } else {
          onChange({preResourceType: prevNodes[0].info.name})
        }
      } else { // 前置节点是去重
        if(initData.extractType && prevNodes[0].data.crowdNames.indexOf(initData.extractType) === -1) {
          onChange({extractType: '', preResourceType: prevNodes[0].info.name})
        } else {
          onChange({preResourceType: prevNodes[0].info.name})
        }
        setExtractionList(prevNodes[0].data.crowdNames);
      }
    } else {

    }
  }, [])

  const formItemLayout = {
    labelCol: {
      span: 5
    },
    wrapperCol: {
      // span: 14
    }
  };

  return (
    <div>
      <div style={{display: prevNodes.length ? "none" : "block"}} className={styles['warning-text']}>请先连接上级节点</div>
      <Form className={`${styles.formDiv} ${styles.extractDiv} canvasDialog`} {...formItemLayout}>
        <Form.Item label="节点名称：" required requiredMessage="请输入节点名称" style={{padding: '30px 30px 0 30px'}}>
          <Input className={`formItemWidth`} name="extractName" placeholder="请输入节点名称" trim size="small" value={data.name} onChange={(name) => onChange({ name })} showLimitHint maxLength={24}/>
        </Form.Item>
        <Form.Item label="选择人群：" required requiredMessage="请选择人群抽取类型" style={{padding: '0 30px'}}>
          <Select size="small" className="formItemWidth search-input-ctrl1" value={data.extractType} onChange={(extractType) => onChange({ extractType })}>
            {
              prevNodes.length && (prevNodes[0].info.name === 'MARKETING_SMS' || prevNodes[0].info.name === 'MARKETING_MSG_BOX') && selectTypeList.map((r,index) => <Select.Option value={r.id} key={`task${r.id}`}>{r.name}</Select.Option>)
            }
            {
              prevNodes.length && prevNodes[0].info.name === 'CROWD_SPLIT' && extractionList.map((r,index) => <Select.Option value={r.searchName} key={`task${r.searchName}`}>{r.searchName}</Select.Option>)
            }
            {
              prevNodes.length && (prevNodes[0].info.name === 'CROWD_DIFFERENCES' || prevNodes[0].info.name === 'CROWD_DIFFERENCE') && extractionList.map((r,index) => <Select.Option value={r} key={`task${r}`}>{r}</Select.Option>)
            }
            {
              prevNodes.length && ['CROWD_INTERSECTION_2', 'CROWD_UNION_2'].indexOf(prevNodes[0].info.name) > -1 && extractionList.map((r,index) => <Select.Option value={r} key={`task${r}`}>{r}</Select.Option>)
            }
          </Select>
        </Form.Item>
        <Form.Item label="上级节点：" style={{padding: '0 30px'}}>
            <span style={{lineHeight: '28px'}}>{prevNodes.length ? data.preActName : '请连接上级节点'}</span>
          {/* <Input disabled className={`formItemWidth`} name="preActName" placeholder="请输入上级节点名称" size="small" value={data.preActName} onChange={(preActName) => onChange({ preActName })} showLimitHint maxLength={24}/> */}
        </Form.Item>
        <hr />
        <div style={{padding: '15px 30px 0 0', height:'60px'}}>
        <Button type="primary" className={`submit-btn ${styles.w88}`} onClick={confirm} style={{float:'right'}}>确认</Button>
          <Button type="normal" className={`cancel-btn ${styles.mr10} ${styles.w88}`} onClick={cancel} style={{float:'right'}}>取消</Button>
        </div>
      </Form>
    </div>
  )
}
